import React from 'react';
import { AppBar, Toolbar, Container, Card, CardContent, CardMedia, Typography, Button, List, ListItem, Grid, Box, TextField, styled } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import ContactUsForm from '../../components/contactus/ContactUsForm';


const PageContainer = styled(Container)(({ theme }) => ({
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  }));
  
  const SectionCard = styled(Card)(({ theme }) => ({
    marginBottom: theme.spacing(5),
    boxShadow: theme.shadows[3],
  }));
  
  const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(2),
  }));
  
  const ContactForm = styled('form')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  }));

const PortfolioRetentionPage= () => {
  return (
    <>
    <LandingPageNav/>
      {/* Promotional Section at the Top */}
      <PageContainer maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          Empowering Success Through Innovation
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Our commitment to your growth is reflected in our clients' success stories. Discover how our tailored solutions have helped businesses achieve remarkable results.
        </Typography>
      </PageContainer>

      {/* Customer Success Stories Section */}
      <PageContainer maxWidth="lg">
        <SectionCard>
          <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2 }}>
            <Typography gutterBottom variant="h5" component="div">
              CUSTOMER SUCCESS STORIES
            </Typography>
            <Typography gutterBottom variant="subtitle1" component="div">
              REAL STORIES, REAL SUCCESS
            </Typography>
            <CardMedia
              component="img"
              image="/assets/portfolioscreenshot.jpg"
              alt="Snapshot of success story"
              sx={{ width: 'auto', height: 'auto', borderRadius: '10%', marginBottom: 2 }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 0 auto', paddingTop: 14 }}>
            <CardContent sx={{ flex: '1 0 auto', padding: 0, '&:last-child': { paddingBottom: 0 } }}>
              <Typography variant="body2" color="text.primary" paragraph>
                Discover how our solutions have transformed businesses and fueled growth across various industries.
              </Typography>
              <List>
                <ListItem>Streamlined Operations & Increased Productivity</ListItem>
                <ListItem>Enhanced Customer Engagement & Satisfaction</ListItem>
                <ListItem>Optimized Lead Management & Conversion Rates</ListItem>
                <ListItem>Comprehensive Analytics & Insightful Reporting</ListItem>
                <ListItem>Customized Solutions for Unique Business Needs</ListItem>
                <ListItem>Scalable Platforms for Growth and Expansion</ListItem>
                <ListItem>Exceptional Support & Partnership</ListItem>
              </List>
            </CardContent>
            {/* Button aligned to the bottom right */}
            
            
          </Box>
        </SectionCard>

        {/* Contact Us Section */}
        <SectionCard>
        <ContactUsForm />
        </SectionCard>
      </PageContainer>
    </>
  );
};

export default PortfolioRetentionPage;
